import { ArrowRight } from 'lucide-react';
import React from 'react';

import type { ComparisonData } from '../../../types/blog';

interface ComparisonProps {
  data: ComparisonData;
}

const Comparison: React.FC<ComparisonProps> = ({ data }) => {
  return (
    <div className="grid sm:grid-cols-[1fr_auto_1fr] gap-4 items-center">
      {/* Before */}
      <div className="rounded-xl bg-red-500/10 border border-red-500/20 p-5">
        <p className="text-xs font-bold uppercase tracking-widest text-red-400 mb-2">Before</p>
        <p className="vscode-text-primary leading-relaxed">{data.before}</p>
      </div>

      {/* Arrow */}
      <div className="hidden sm:flex items-center justify-center">
        <ArrowRight className="w-6 h-6 vscode-text-secondary" />
      </div>

      {/* After */}
      <div className="rounded-xl bg-green-500/10 border border-green-500/20 p-5">
        <p className="text-xs font-bold uppercase tracking-widest text-green-400 mb-2">After</p>
        <p className="vscode-text-primary leading-relaxed">{data.after}</p>
      </div>
    </div>
  );
};

export default Comparison;
